module.exports = {"530802001":"思茅街道","530802102":"南屏镇","530802103":"倚象镇","530802104":"思茅港镇","530802105":"六顺镇","530802201":"龙潭彝族傣族乡","530802202":"云仙彝族乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/530802.json
// module id = 2731
// module chunks = 0